import { post } from '@/service/api';

export async function logUserAction(action, username, details = '') {
  const logEntry = {
    action,
    username,
    details,
    timestamp: new Date().toISOString(),
  };

  try {
    const response = await post('Comm/LogUserAction', logEntry);
    return response;
  } catch (error) {
    console.error('Failed to log user action:', error.response ? error.response.data : error);
    throw error;
  }
}